import {Mapper} from '@s-ui/domain'

import {FiltersSearchValueObject} from '../../search/ValueObjects/FiltersSearchValueObject.js'

export class FromUserAlertsParamsToRequestValueObjectMapper extends Mapper {
  constructor({config, parsedUserAlertEntity}) {
    super()
    this._config = config
    this._parsedUserAlertEntity = parsedUserAlertEntity
    this._frequencyNotificationData = this._config.get('alerts').frequencyNotificationData
  }

  checkValidValue = value => {
    return !!value
  }

  getInstalment = instalment => {
    if (typeof instalment !== 'object' || Object.keys(instalment).length === 0) return {instalment: {from: 1, to: null}}

    if (!this.checkValidValue(instalment?.from) && !this.checkValidValue(instalment?.to))
      return {instalment: {from: 1, to: null}}

    return {instalment: instalment || null}
  }

  map = ({userAlert, activeEmail, activePush}) => {
    const {filters, frequencyNotification} = userAlert

    const filtersSearchValueObject = FiltersSearchValueObject.createFromFilters({config: this._config, filters})

    const parsedUserAlert = {
      activeEmail,
      activePush,
      ...this._frequencyNotificationData[frequencyNotification],
      filters: filtersSearchValueObject.getSearchFromFilters()
    }

    return this._parsedUserAlertEntity({...parsedUserAlert})
  }
}
